'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';
import { colors } from '../Colors/index.js';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .placeholder {\n        color: ", ";\n        font-style: normal;\n    }\n"], ["\n    .placeholder {\n        color: ", ";\n        font-style: normal;\n    }\n"])), colors.grey[60]);
var templateObject_1;

export { Container };
//# sourceMappingURL=JobFunction.css.js.map
